<div class="flex h-full w-full bg-body-background relative overflow-hidden">
  <div class="flex-1 flex flex-col min-w-0 h-full relative bg-component-inner">
    @if (isV2()) {
      <!-- Modernized Chat V2 Message Area Hook (Milestone 1 Foundation) -->
      <div
        #scrollContainer
        (scroll)="onContainerScroll()"
        class="flex-1 overflow-y-auto custom-scrollbar p-2 lg:p-2 flex flex-col min-h-0 relative chat-v2-container"
      >
        @if (isLoadingMessages()) {
          <div class="flex items-center justify-center h-full w-full">
            <i class="fas fa-circle-notch fa-spin text-4xl text-primary"></i>
          </div>
        } @else {
          @if (messages().length === 0) {
            <div
              class="flex flex-col items-center justify-center h-full text-center max-w-md mx-auto animate-fade-in-up"
            >
              <div
                class="w-20 h-20 bg-alt-background border border-secondary-border rounded-full flex items-center justify-center mb-6 shadow-sm"
              >
                <i class="fas fa-robot text-3xl text-primary"></i>
              </div>
              <h2 class="text-2xl font-bold text-heading mb-2">
                {{ config.texts.emptyChatTitle }}
              </h2>
              <p class="text-secondary-text">
                {{ config.texts.emptyChatSubtitle }}
              </p>
            </div>
          }

          <!-- Chat V2 Message List Foundation: Prepared hook for V2 messages -->
          <div class="chat-v2-message-list flex flex-col w-full">
            @for (
              msg of visibleMessages();
              track msg.id + '-' + $index;
              let last = $last
            ) {
              <rapider-chat-v2-message-bubble
                [message]="msg"
                [isLatest]="last"
                (onTypingProgress)="performAutoScroll(true)"
              >
              </rapider-chat-v2-message-bubble>
            }
          </div>

          @if (isAiThinking() && !hasStreamingAiMessage()) {
            <div class="flex items-start gap-2 mb-6 ml-1 animate-fade-in">
              <i class="fas fa-sparkles text-primary text-xs mt-1"></i>
              <div
                class="bg-component-inner border border-primary-border rounded-2xl rounded-tl-sm px-5 py-4 shadow-sm flex items-center gap-1.5"
              >
                <div
                  class="w-1.5 h-1.5 bg-secondary-text rounded-full animate-bounce"
                ></div>
                <div
                  class="w-1.5 h-1.5 bg-secondary-text rounded-full animate-bounce"
                  style="animation-delay: 0.15s"
                ></div>
                <div
                  class="w-1.5 h-1.5 bg-secondary-text rounded-full animate-bounce"
                  style="animation-delay: 0.3s"
                ></div>
              </div>
            </div>
          }
        }
      </div>
    } @else {
      <!-- Legacy Chat V1 Container (Untouched 100% Fallback) -->
      <div
        #scrollContainer
        (scroll)="onContainerScroll()"
        class="flex-1 overflow-y-auto custom-scrollbar p-2 lg:p-2 flex flex-col min-h-0 relative"
      >
        @if (isLoadingMessages()) {
          <div class="flex items-center justify-center h-full w-full">
            <i class="fas fa-circle-notch fa-spin text-4xl text-primary"></i>
          </div>
        } @else {
          @if (messages().length === 0) {
            <div
              class="flex flex-col items-center justify-center h-full text-center max-w-md mx-auto animate-fade-in-up"
            >
              <div
                class="w-20 h-20 bg-alt-background border border-secondary-border rounded-full flex items-center justify-center mb-6 shadow-sm"
              >
                <i class="fas fa-robot text-3xl text-primary"></i>
              </div>
              <h2 class="text-2xl font-bold text-heading mb-2">
                {{ config.texts.emptyChatTitle }}
              </h2>
              <p class="text-secondary-text">
                {{ config.texts.emptyChatSubtitle }}
              </p>
            </div>
          }

          @for (
            msg of messages();
            track msg.id + '-' + $index;
            let last = $last
          ) {
            @if (msg.isShownInChat !== false && !msg.isHidden) {
              <rapider-chat-message-bubble [message]="msg" [isLatest]="last">
              </rapider-chat-message-bubble>
            }
          }

          @if (isAiThinking()) {
            <div class="flex items-start gap-2 mb-6 ml-1 animate-fade-in">
              <i class="fas fa-sparkles text-primary text-xs mt-1"></i>
              <div
                class="bg-component-inner border border-primary-border rounded-2xl rounded-tl-sm px-5 py-4 shadow-sm flex items-center gap-1.5"
              >
                <div
                  class="w-1.5 h-1.5 bg-secondary-text rounded-full animate-bounce"
                ></div>
                <div
                  class="w-1.5 h-1.5 bg-secondary-text rounded-full animate-bounce"
                  style="animation-delay: 0.15s"
                ></div>
                <div
                  class="w-1.5 h-1.5 bg-secondary-text rounded-full animate-bounce"
                  style="animation-delay: 0.3s"
                ></div>
              </div>
            </div>
          }
        }
      </div>
    }

    <div class="shrink-0 w-full p-4 bg-body-background">
      <rapider-chat-input
        (onSendMessage)="handleUserMessage($event)"
        (onSendVoice)="handleVoiceMessage($event)"
      >
      </rapider-chat-input>
    </div>
  </div>
</div>
